import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/hooks/useAuth'
import { createSupabaseClient } from '@/integrations/supabase/client'

interface UsePortfoliosProps {
  organizationId: string | null
}

export const usePortfolios = ({ organizationId }: UsePortfoliosProps) => {
  const { getToken } = useAuth()
  const supabase = createSupabaseClient(() =>
    organizationId ? getToken({ organizationId, skipCache: true }) : getToken()
  )

  const {
    data: portfolios = [],
    isPending,
    error,
  } = useQuery({
    queryKey: ['portfolios', organizationId],
    enabled: !!organizationId,
    queryFn: async () => {
      const portfolios = await supabase
        .from('portfolios')
        .select('id, name')
        .eq('organization_id', organizationId!)
        .is('deleted_at', null)

      if (portfolios.error) {
        throw portfolios.error
      }

      return portfolios.data ?? []
    },
  })

  return {
    portfolios,
    isPending,
    error,
  }
}
